import React, { memo, useCallback, useMemo } from "react";
import { Input, Select, Tooltip } from "antd";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { eggsDonorOptions, eggsOptions } from "utils/FieldValues";
import { embryology_countTable, isOpenBy } from "./Constant";
import {
  getPatientList,
  getEggsToSpermByPatientList,
  setBackupIvfDonerList,
  setBackupIvfList,
  setEmbryologyDetails,
  setIsSearchPatient,
  setPatientDetailsEDS,
  setEggsToPatientList,
  setEggsToBackupList,
  setEggsToDonorPatientList,
  setEggsToDonorBackupList,
} from "redux/reducers/EmbryologyData/embryologyData.slice";
import EmbryologyPartnerDetails from "./EmbryologyPartnerDetails";

const EmbryologyPatientDetails = (props) => {
  const {
    // pDetail,
    setFieldValue,
    formValues,
    // formikRef,
    handleEggsByChange,
    onChangeEggsTo,
    handleDonorChange,
    // handleClearSearch,
    // handleClearSearchDonor
  } = props;

  const dispatch = useDispatch();
  // const formDetails = formikRef.current?.formValues || {};
  // const formDetails = { ...formValues } || {};

  const { selectedLocation } = useSelector(({ role }) => role);
  const { selectedPatient } = useSelector(({ common }) => common);
  const { IvfFlowsheetList } = useSelector(({ ivfFlowSheet }) => ivfFlowSheet);
  const {
    patientList,
    ivfIdOption,
    backupIvfList,
    embryologyData,
    isSearchPatient,
    eggsByBackupList,
    patientDetailsEDS,
    embryologyDetails,
    backupIvfDonerList,
    eggsByIvfOptionTemp,
    eggsToIvfOptionTemp,
    eggsByDonorBackupList,
    eggsByIvfDonorOptionTemp,
    eggsToSpermByPatientList,
    eggsToPatientList,
    eggsToBackupList,
    eggsToDonorBackupList,
    eggsToDonorPatientList,
  } = useSelector(({ embryologyData }) => embryologyData);

  const eggsToIvfIdsOptions = useMemo(() => {
    return (
      eggsToIvfOptionTemp?.map((d) => ({
        value: d?._id,
        label: d?.ivf_id,
        disabled: d?.disable || false,
      })) || []
    );
  }, [eggsToIvfOptionTemp]);

  const handleEggIvfSelect = (value) => {
    const { eggs_by_ivf_id: previousIvfIds = [], ivf_flow_id } =
      patientDetailsEDS;

    const allIvfOptions = eggsByIvfOptionTemp ?? [];
    let oocytes = [...(formValues?.oocytes || [])];

    const copyBackupIvf = JSON.parse(JSON.stringify(backupIvfList));

    // Get details of currently selected IVFs
    const selectedAllEggsByIVFDetails = allIvfOptions?.filter((ivf) =>
      value.includes(ivf?._id)
    );

    // const previousSelectedEggsByIvfIds = patientDetailsEDS.eggs_by_ivf_id ?? []

    // Get new selections (not previously selected)
    const newSelectedIvfIds = selectedAllEggsByIVFDetails?.filter(
      (patient) => !previousIvfIds?.includes(patient._id)
    );

    // Identify deselected IVFs
    const previousSelectedData = allIvfOptions?.filter((ivf) =>
      previousIvfIds?.includes(ivf?._id)
    );

    const deselectedIvfIds = previousSelectedData.filter(
      (item) => !selectedAllEggsByIVFDetails.some((ivf) => ivf._id === item._id)
    );

    if (copyBackupIvf.length === 0) {
      copyBackupIvf.push({ ...newSelectedIvfIds[0] });
      dispatch(setBackupIvfList(copyBackupIvf));
    } else {
      const removedIvf = copyBackupIvf.filter(
        (ivf) => !value.some((newIvf) => newIvf === ivf._id)
      );

      if (removedIvf.length) {
        const filterIvf = copyBackupIvf.filter((ivf) =>
          value.some((newIvf) => newIvf === ivf._id)
        );
        dispatch(setBackupIvfList(filterIvf));
      } else {
        copyBackupIvf.push({ ...newSelectedIvfIds[0] });
        dispatch(setBackupIvfList(copyBackupIvf));
      }
    }

    const retainedIvfIds = selectedAllEggsByIVFDetails?.filter((patient) =>
      previousIvfIds?.includes(patient._id)
    );

    const updatedIvfIds = [...retainedIvfIds, ...newSelectedIvfIds]?.map(
      (ivf) => ivf._id
    );

    dispatch(
      setPatientDetailsEDS({
        ...patientDetailsEDS,
        eggs_by_ivf_id: updatedIvfIds.length ? updatedIvfIds : null,
      })
    );

    const latestSelectedIvf = allIvfOptions.find(
      (item) => item._id === newSelectedIvfIds[0]?._id
    );

    if (value?.length > 0) {
      // Add new IVF-related oocyte table

      if (newSelectedIvfIds?.length > 0) {
        const oocyteEntry = {
          ...embryology_countTable,
          total_m2_used: latestSelectedIvf?.total_m2_used ?? "",
          patient_detail: {
            patientId: latestSelectedIvf?.patient_reg_id,
            patientName: latestSelectedIvf?.patient_full_name,
            ivf: latestSelectedIvf,
            isDonor: false,
          },
          embryo: [],
        };

        // Case 1: No existing data
        if (formValues?.oocytes?.length === 0) {
          oocytes.push(oocyteEntry);
        } else if (oocytes?.length > 0) {
          //Check if the id exists in the array

          // const patientDetail = newA?.find(
          //   (item) =>
          //     !value.includes(item?.patient_detail?.ivf?._id) &&
          //     // item.patient_detail.patientId === patient_id &&
          //     !item.patient_detail.isDonor
          // );

          const unrelatedOocyte = oocytes?.find(
            (item) =>
              item?.patient_detail?.ivf?._id &&
              !value.includes(item.patient_detail.ivf._id) &&
              !item.patient_detail.isDonor
          );

          // If already selected self IVF-Id and related there Oocyte table and, then select the Eggs-By-IVF-Id
          const isSelfIVFTableExist = oocytes.find(
            (item) =>
              !previousIvfIds?.length &&
              item.patient_detail?.ivf?._id === ivf_flow_id
          );

          if (isSelfIVFTableExist) {
            oocytes = [oocyteEntry];
          } else if (!unrelatedOocyte) {
            oocytes.push(oocyteEntry);
          } else {
            //Remove ivf which is not in the selected list and stay donor ivf
            // Keep donor IVFs and selected IVFs only
            oocytes = oocytes?.filter(
              (item) =>
                item.patient_detail?.isDonor ||
                value.includes(item?.patient_detail?.ivf?._id) ||
                value.includes(item?.patient_detail?.patientId)
              //  ||
              // copyBackupIvf.some((a) => a.ivf_id === item.patient_detail.ivf.ivf_id)
            );
          }
        }
      }

      if (deselectedIvfIds?.length > 0) {
        const isOocyteTableExist = oocytes.some((item) =>
          deselectedIvfIds.some(
            (removed) => item.patient_detail.ivf._id === removed._id
          )
        );

        if (isOocyteTableExist) {
          oocytes = oocytes.filter(
            (item) =>
              !deselectedIvfIds.some(
                (removed) => item.patient_detail.ivf._id === removed._id
              )
          );
        }
      }
    } else {
      // If unselect all IVF-Ids from Eggs-By-IVF-ID then add the Oocyte table depend on Self Ivf-Id.
      // If all IVF IDs unselected → reset to Self IVF oocyte

      const selectedIvfOption = ivfIdOption.find(
        (opt) => opt.value === ivf_flow_id
      );

      const selfOocyte = {
        ...embryology_countTable,
        patient_detail: {
          patientId: selectedPatient?._id,
          patientName: selectedPatient?.patient_full_name,
          ivf: {
            ivf_id: selectedIvfOption?.label,
            _id: selectedIvfOption?.value,
          },
          isDonor: false,
        },
        embryo: [],
      };

      oocytes = [selfOocyte];
    }

    // dispatch(setEmbryology_count(newA));
    // formikRef.current?.setFieldValue("oocytes", newA);
    setFieldValue("oocytes", oocytes);
  };

  const onChangeEggsToIvfId = (value) => {
    dispatch(
      setPatientDetailsEDS({
        ...patientDetailsEDS,
        eggs_to_ivf_id: value || null,
      })
    );
  };

  const eggsByOptions = () => {
    const uniqueEggsByPrevSelectedData = _.uniqBy(
      embryologyData?.eggs_by,
      (item) => item._id || item.id
    );

    const getId = (item) => item._id || item.id;

    const combinedOptionsArray = [
      // ...patientList,
      ...(uniqueEggsByPrevSelectedData || []),
      ...(eggsByBackupList || []),
    ];

    // Ensure unique base array (optional)
    const uniqueCombined = Array.from(
      new Map(combinedOptionsArray.map((item) => [getId(item), item])).values()
    );

    // Filter patientList — remove duplicates by ID
    const filteredPatientList = patientList.filter(
      (patient) => !uniqueCombined.some((opt) => getId(opt) === getId(patient))
    );

    // Merge back
    const finalCombinedArray = [...uniqueCombined, ...filteredPatientList];

    // remove the global searched patient from options
    const removeGlobalSearchedPatientFromOptions = finalCombinedArray?.filter(
      (item) => {
        return item?.id !== selectedPatient?._id;
      }
    );

    // const combinedOptions = isSearchPatient ? combinedOptionsArray : embryologyData?.eggs_by;

    return removeGlobalSearchedPatientFromOptions
      ?.filter(
        (d, index, self) =>
          index ===
          self.findIndex(
            (t) =>
              (t?.id || t?._id) === (d?.id || d?._id) &&
              (t?.name !== "" || t?.patient_full_name !== "")
          )
      )
      ?.map((d) => ({
        value: d?.id ? d?.id : d?._id,
        label: d?.name ? d?.name : d?.patient_full_name,
        disabled: patientDetailsEDS?.eggs_by?.includes(d?.id),
      }));
  };

  const handleEggsChange = (value, key) => {
    let patientDetailsObj = { ...patientDetailsEDS };

    if (value === "Own Fresh" && key === "eggs") {
      // const selectedIvf = ivfIdOption.find(
      //   (item) => item.value === embryologyDetails?.ivf_flow_id
      // );

      const selectedIvf = ivfIdOption.find(
        (item) => item.value === patientDetailsEDS?.ivf_flow_id
      );
      let newA = [...formValues?.oocytes];
      let updatedEmbryologyCount = newA.filter(
        (item) => item.patient_detail.isDonor
      );
      const embryoData = [
        ...updatedEmbryologyCount,
        {
          ...embryology_countTable,
          patient_detail: {
            patientId: selectedPatient?._id,
            patientName: selectedPatient?.patient_full_name,
            ivf: { ivf_id: selectedIvf?.label, _id: selectedIvf?.value },
            isDonor: false,
          },
          embryo: [],
        },
      ];

      patientDetailsObj.eggs_by = [];
      patientDetailsObj.eggs_by_ivf_id = [];
      // dispatch(setEmbryology_count(embryoData));
      // formikRef.current?.setFieldValue("oocytes", embryoData);
      setFieldValue("oocytes", embryoData);

      // const obj = {};
      // Object.keys(embryology_countTable).map((key, index) => {
      //   obj[`${key}${embryoData.length - 1}`] = "";
      // });
      // form.setFieldsValue({
      //   ...obj
      // });
    } else if (value === "Own Fresh" && key === "eggs_donor") {
      let newA = [...formValues?.oocytes];

      let updatedEmbryologyCount = newA.filter(
        (item) => !item.patient_detail.isDonor
      );

      // dispatch(setEmbryology_count(updatedEmbryologyCount));
      patientDetailsObj.eggs_by_donor = [];
      patientDetailsObj.eggs_by_ivf_id_donor = [];

      // formikRef.current?.setFieldValue("oocytes", updatedEmbryologyCount);
      setFieldValue("oocytes", updatedEmbryologyCount);
    }

    dispatch(
      setPatientDetailsEDS({
        // ...patientDetailsEDS,
        ...patientDetailsObj,
        [key]: value || null,
      })
    );
  };

  const eggsByDonorOptions = useCallback(() => {
    const combinedOptionsArray = [
      ...patientList,
      ...(embryologyData?.eggs_by_donor || []),
      ...(eggsByDonorBackupList || []),
    ];

    const combinedOptions = isSearchPatient
      ? combinedOptionsArray
      : embryologyData?.eggs_by_donor;

    return combinedOptions
      ?.filter(
        (d, index, self) =>
          index ===
          self.findIndex(
            (t) =>
              (t?.id || t?._id) === (d?.id || d?._id) &&
              (t?.name !== "" || t?.patient_full_name !== "")
          )
      )
      ?.map((d) => ({
        value: d?.id ? d?.id : d?._id,
        label: d?.name ? d?.name : d?.patient_full_name,
        // disabled: embryologyDetails?.eggs_by_donor?.includes(d?.id)
        disabled: patientDetailsEDS?.eggs_by_donor?.includes(d?.id),
      }));
  }, [
    patientList,
    embryologyData,
    isSearchPatient,
    patientDetailsEDS,
    eggsByDonorBackupList,
  ]);

  const handleEggIvfSelectDonor = useCallback(
    (value) => {
      const ifvDetails = eggsByIvfDonorOptionTemp?.filter((ivf) =>
        value.includes(ivf?._id)
      );
      // const existingIvfIds = embryologyDetails.eggs_by_ivf_id_donor
      //   ? embryologyDetails.eggs_by_ivf_id_donor?.map((id) => id)
      //   : [];
      const existingIvfIds = patientDetailsEDS.eggs_by_ivf_id_donor
        ? patientDetailsEDS.eggs_by_ivf_id_donor?.map((id) => id)
        : [];
      const newIvfs = ifvDetails?.filter(
        (patient) => !existingIvfIds.includes(patient._id)
      );
      const copyBackupIvf = JSON.parse(JSON.stringify(backupIvfDonerList));

      if (copyBackupIvf.length === 0) {
        copyBackupIvf.push({ ...newIvfs[0] });
        dispatch(setBackupIvfDonerList(copyBackupIvf));
      } else {
        const removedIvf = copyBackupIvf.filter(
          (ivf) => !value.some((newIvf) => newIvf === ivf._id)
        );
        if (removedIvf.length) {
          const filterIvf = copyBackupIvf.filter((ivf) =>
            value.some((newIvf) => newIvf === ivf._id)
          );
          dispatch(setBackupIvfDonerList(filterIvf));
        } else {
          copyBackupIvf.push({ ...newIvfs[0] });
          dispatch(setBackupIvfDonerList(copyBackupIvf));
        }
      }
      const oldIvfs = ifvDetails?.filter((patient) =>
        existingIvfIds.includes(patient._id)
      );

      const newIvfValue = [...oldIvfs, ...newIvfs]?.map((ivf) => ivf._id);
      // dispatch(
      //   setEmbryologyDetails({
      //     ...embryologyDetails,
      //     eggs_by_ivf_id_donor: newIvfValue || null
      //   })
      // );

      dispatch(
        setPatientDetailsEDS({
          ...patientDetailsEDS,
          eggs_by_ivf_id_donor: newIvfValue || null,
        })
      );
      // form.setFieldsValue({
      //   eggs_by_ivf_id_donor: newIvfValue || null
      // });

      // Managed embryo table
      const selectedIvf = eggsByIvfDonorOptionTemp.find(
        (item) => item._id === newIvfs[0]?._id
      );
      let newA = [...formValues?.oocytes];
      if (formValues?.oocytes.length === 0) {
        newA.push({
          ...embryology_countTable,
          patient_detail: {
            patientId: selectedIvf.patient_reg_id,
            patientName: selectedIvf.patient_full_name,
            ivf: selectedIvf,
            isDonor: true,
          },
          embryo: [],
        });
      } else if (newA.length > 0) {
        //Check if the id exists in the array
        const patientDetail = newA.find(
          (item) =>
            !value.includes(item.patient_detail.ivf._id) &&
            // item.patient_detail.patientId === patient_id &&
            item.patient_detail.isDonor
        );

        if (!patientDetail) {
          newA.push({
            ...embryology_countTable,
            patient_detail: {
              patientId: selectedIvf.patient_reg_id,
              patientName: selectedIvf.patient_full_name,
              ivf: selectedIvf,
              isDonor: true,
            },
            embryo: [],
          });
        } else {
          //Remove ivf which is not in the selected list and stay donor ivf
          newA = newA.filter(
            (item) =>
              !item.patient_detail.isDonor ||
              value.includes(item.patient_detail.ivf._id) ||
              value.includes(item.patient_detail.patientId)
          );
        }
      }

      // dispatch(setEmbryology_count(newA));
      // formikRef.current?.setFieldValue("oocytes", newA);
      setFieldValue("oocytes", newA);
    },
    [dispatch, backupIvfDonerList, eggsByIvfDonorOptionTemp, patientDetailsEDS]
  );

  const handleIvfId = useCallback(
    (id) => {
      const findList = ivfIdOption?.find((item) => item.value === id);
      // const updatedEmbryologyData = embryologyData?.embryo?.map((item) => {
      //   return {
      //     ...item,
      //     vitrified_by: item?.vitrified_by ? item?.vitrified_by?.split(",") : ""
      //   };
      // });
      // const newPackageData = transformData(
      //   updatedEmbryologyData || [embryoTable]
      // );

      if (findList) {
        // setEmbryoTableList(updatedEmbryologyData || [embryoTable]);

        dispatch(
          setEmbryologyDetails({
            ivf_flow_id: findList?.value,
            protocol: findList?.protocol,
          })
        );
      }
    },
    [dispatch, ivfIdOption]
  );

  const handleSearch = useCallback(
    (newValue, selectedLocation, selectedPatientId) => {
      if (newValue && selectedLocation && selectedPatientId) {
        dispatch(
          getPatientList({
            patient_name: newValue,
            start: null,
            limit: null,
            patient_reg_id: selectedPatientId,
          })
        );
      }
    },
    [dispatch]
  );

  const handleEggsToSearch = useCallback(
    (newValue, selectedLocation, selectedPatientId, key_name) => {
      if (newValue && selectedLocation && selectedPatientId) {
        dispatch(
          getEggsToSpermByPatientList({
            patient_name: newValue,
            start: null,
            limit: null,
            patient_reg_id: selectedPatientId,
            key_name,
          })
        );
      }
    },
    [dispatch]
  );

  const globalSearchTextChange = useCallback(_.debounce(handleSearch, 800), []);
  const searchEggsToTextChange = useCallback(
    _.debounce(handleEggsToSearch, 800),
    []
  );

  const handleStorePatientDetails = useCallback(
    (key, value) => {
      dispatch(
        setPatientDetailsEDS({
          ...patientDetailsEDS,
          [key]: value || null,
        })
      );
    },
    [dispatch, patientDetailsEDS]
  );

  return (
    <>
      <div className="form_info_wrapper filled">
        <h3 className="mb-3">Patient Details</h3>
        <ul className="grid_wrapper">
          <li className="w_270 w_xs_50">
            {/* <Form.Item label="Eggs" className="custom_select"> */}
            <div className="custom_select spacing-manage">
              <label htmlFor="">Eggs</label>
              <Select
                showSearch
                name="eggs"
                allowClear={true}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                filterSort={(optionA, optionB) =>
                  optionA.label
                    .toLowerCase()
                    .localeCompare(optionB.label.toLowerCase())
                }
                placeholder="Select"
                value={patientDetailsEDS?.eggs}
                onChange={(value) => {
                  // handleClearSearch();
                  handleEggsChange(value, "eggs");
                }}
                options={eggsOptions}
              />
            </div>
            {/* </Form.Item> */}
          </li>
          {isOpenBy.includes(patientDetailsEDS?.eggs) && (
            <li className="w_270 w_xs_50">
              {/* <div className="search_top"> */}
              <div className="">
                {/* <Form.Item
                  label="Eggs By"
                  // className="custom_select search_with_select"
                  className="custom_select search_with_select select_with_hover"
                > */}
                <div className="custom_select search_with_select select_with_hover  spacing-manage">
                  <label htmlFor="">Eggs By</label>
                  <Select
                    showSearch
                    name="eggs_by"
                    allowClear={false}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.label
                        ?.toLowerCase()
                        ?.indexOf(input?.toLowerCase()) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.label
                        ?.toLowerCase()
                        ?.localeCompare(optionB?.label?.toLowerCase())
                    }
                    value={patientDetailsEDS?.eggs_by}
                    placeholder="Search here"
                    mode="multiple"
                    maxTagCount="responsive"
                    onSearch={(e) => {
                      Object.keys(selectedPatient)?.length > 0 &&
                        globalSearchTextChange(
                          e,
                          selectedLocation,
                          selectedPatient?._id
                        );
                      setTimeout(() => {
                        dispatch(setIsSearchPatient(true));
                      }, 1000);
                    }}
                    onChange={(e) => handleEggsByChange(e, "eggs_by")}
                    options={eggsByOptions()}
                    maxTagPlaceholder={(omittedValues) => (
                      <Tooltip
                        title={omittedValues
                          .map(({ label }) => label)
                          .join(", ")}
                      >
                        <span>Hover Me</span>
                      </Tooltip>
                    )}
                  />
                </div>
                {/* </Form.Item> */}
              </div>
            </li>
          )}
          {isOpenBy.includes(patientDetailsEDS?.eggs) &&
            embryologyDetails?.cycle_type?.includes("OD") && (
              <li className="w_270 w_xs_100">
                {/* <Form.Item label="Eggs By IVF ID" className="custom_select"> */}
                <div className="custom_select spacing-manage">
                  <label htmlFor="">Eggs By IVF ID</label>
                  <Select
                    showSearch
                    allowClear={false}
                    name="eggs_by_ivf_id"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.label
                        ?.toLowerCase()
                        .indexOf(input?.toLowerCase()) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.label
                        ?.toLowerCase()
                        ?.localeCompare(optionB.label.toLowerCase())
                    }
                    placeholder="Select"
                    options={eggsByIvfOptionTemp?.map((d) => ({
                      value: d?._id,
                      label: d?.ivf_id,
                      disabled: d?.disable || false,
                    }))}
                    mode="multiple"
                    maxTagCount="responsive"
                    value={patientDetailsEDS?.eggs_by_ivf_id}
                    maxTagPlaceholder={(omittedValues) => (
                      <Tooltip
                        title={omittedValues
                          .map(({ label }) => label)
                          .join(", ")}
                      >
                        <span>Hover Me</span>
                      </Tooltip>
                    )}
                    onChange={(e) => {
                      handleEggIvfSelect(e || null);
                    }}
                  />
                </div>
                {/* </Form.Item> */}
              </li>
            )}

          {IvfFlowsheetList?.planned_cycle?.includes("Professional Donor") && (
            <li className="w_270 w_xs_50">
              {/* <Form.Item
                label="Eggs To"
              > */}
              <div
                className={
                  patientDetailsEDS?.eggs_to
                    ? "custom_select select_with_hover spacing-manage"
                    : "custom_select spacing-manage"
                }
              >
                <label htmlFor="">Eggs To</label>
                <Select
                  showSearch
                  allowClear={true}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.label
                      ?.toLowerCase()
                      ?.indexOf(input?.toLowerCase()) >= 0
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.label
                      ?.toLowerCase()
                      ?.localeCompare(optionB?.label?.toLowerCase())
                  }
                  name="eggs_to"
                  mode="multiple"
                  maxTagCount="responsive"
                  value={patientDetailsEDS?.eggs_to}
                  placeholder="Search here"
                  onSearch={(e) => {
                    Object.keys(selectedPatient)?.length > 0 &&
                      // globalSearchTextChange(e, selectedLocation);
                      searchEggsToTextChange(
                        e,
                        selectedLocation,
                        selectedPatient?._id,
                        "eggs_to"
                      );
                  }}
                  onChange={(value) => {
                    onChangeEggsTo(value, "eggs_to");

                    // handleStorePatientDetails("eggs_to", value);

                    // const currentWithBackupOptionsList = _.uniqBy(
                    //   [...eggsToPatientList, ...eggsToBackupList],
                    //   "_id"
                    // );

                    // const findOptionFromList =
                    //   currentWithBackupOptionsList?.filter((item) =>
                    //     value.includes(item?._id)
                    //   );

                    // dispatch(setEggsToPatientList(findOptionFromList));
                    // dispatch(setEggsToBackupList(findOptionFromList));
                  }}
                  // options={(patientList || []).map((d) => ({
                  //   value: d?._id,
                  //   label: d?.patient_full_name
                  // }))}
                  options={(eggsToPatientList || [])?.map((d) => ({
                    value: d?._id,
                    label: d?.patient_full_name,
                  }))}
                  maxTagPlaceholder={(omittedValues) => (
                    <Tooltip
                      title={omittedValues
                        ?.map(({ label }) => label)
                        .join(", ")}
                    >
                      <span>Hover Me</span>
                    </Tooltip>
                  )}
                />

                {/* {Object.keys(pDetail)?.length > 0 && (
                  <Button
                    className="clearIcon btn_transparent"
                    onClick={handleClearSearch}
                  >
                    <CloseOutlined />
                  </Button>
                )} */}
              </div>
              {/* </Form.Item> */}
            </li>
          )}

          {IvfFlowsheetList?.planned_cycle?.includes("Professional Donor") && (
            <li className="w_270 w_xs_100">
              <div className="custom_select spacing-manage">
                <label htmlFor="">Eggs To IVF ID</label>
                <Select
                  showSearch
                  allowClear={false}
                  name="eggs_to_ivf_id"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.label?.toLowerCase().indexOf(input?.toLowerCase()) >=
                    0
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.label
                      ?.toLowerCase()
                      ?.localeCompare(optionB.label.toLowerCase())
                  }
                  placeholder="Select"
                  options={eggsToIvfIdsOptions}
                  mode="multiple"
                  maxTagCount="responsive"
                  value={patientDetailsEDS?.eggs_to_ivf_id}
                  maxTagPlaceholder={(omittedValues) => (
                    <Tooltip
                      title={omittedValues.map(({ label }) => label).join(", ")}
                    >
                      <span>Hover Me</span>
                    </Tooltip>
                  )}
                  onChange={(e) => {
                    onChangeEggsToIvfId(e || null);
                  }}
                />
              </div>
            </li>
          )}

          <li className="w_270 w_xs_50">
            {/* <Form.Item label="Planned Cycle"> */}
            <div className="custom_normal_input spacing-manage">
              <label htmlFor="">Planned Cycle</label>
              <Input
                placeholder="Enter Planned Cycle"
                name="plan_cycle"
                value={
                  IvfFlowsheetList?.planned_cycle
                    ? IvfFlowsheetList?.planned_cycle.join()
                    : ""
                }
                disabled
              />
            </div>
            {/* </Form.Item> */}
          </li>
          <li className="w_270 w_xs_50">
            {/* <Form.Item label="Protocol"> */}
            <div className="custom_normal_input spacing-manage">
              <label htmlFor="">Protocol</label>
              <Input
                name="protocol"
                placeholder="Enter Protocol"
                value={IvfFlowsheetList?.protocol || null}
                disabled
              />
            </div>
            {/* </Form.Item> */}
          </li>
          <li className="w_270 w_xs_50">
            {/* <Form.Item label="IVF ID" className="custom_select"> */}
            <div className="custom_select spacing-manage spacing-manage">
              <label htmlFor="">IVF ID</label>
              <Select
                showSearch
                allowClear={true}
                name="ivf_flow_id"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                filterSort={(optionA, optionB) =>
                  optionA.label
                    .toLowerCase()
                    .localeCompare(optionB.label.toLowerCase())
                }
                placeholder="Select"
                options={ivfIdOption}
                value={patientDetailsEDS?.ivf_flow_id}
                onChange={(e) => {
                  dispatch(
                    setPatientDetailsEDS({
                      ...patientDetailsEDS,
                      ivf_flow_id: e || null,
                    })
                  );

                  handleIvfId(e || null);
                }}
              />
            </div>
            {/* </Form.Item> */}
          </li>
        </ul>
      </div>
      {IvfFlowsheetList?.planned_cycle?.includes("Fresh") &&
        IvfFlowsheetList?.planned_cycle?.includes("OD") && (
          <div className="form_info_wrapper filled">
            <h3 className="mb-3">Patient Details (Donor)</h3>
            <ul className="grid_wrapper">
              <li className="w_270 w_xs_50">
                {/* <Form.Item label="Eggs" className="custom_select"> */}
                <div className="custom_select spacing-manage">
                  <label htmlFor="">Eggs</label>
                  <Select
                    showSearch
                    allowClear={true}
                    name="eggs_donor"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().indexOf(input.toLowerCase()) >=
                      0
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.label
                        .toLowerCase()
                        .localeCompare(optionB.label.toLowerCase())
                    }
                    placeholder="Select"
                    value={patientDetailsEDS?.eggs_donor}
                    onChange={(value) => {
                      // handleClearSearchDonor();
                      handleEggsChange(value, "eggs_donor");
                    }}
                    options={eggsDonorOptions}
                  />
                </div>
                {/* </Form.Item> */}
              </li>
              {isOpenBy.includes(patientDetailsEDS?.eggs_donor) && (
                <li className="w_270 w_xs_50">
                  {/* <div className="search_top"> */}
                  <div className="">
                    {/* <Form.Item
                      label="Eggs By"
                      className="custom_select select_with_hover"
                    > */}
                    <div className="custom_select select_with_hover spacing-manage">
                      <label htmlFor="">Eggs By</label>
                      <Select
                        showSearch
                        allowClear={false}
                        name="eggs_by_donor"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.label
                            ?.toLowerCase()
                            ?.indexOf(input?.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.label
                            ?.toLowerCase()
                            ?.localeCompare(optionB?.label?.toLowerCase())
                        }
                        value={patientDetailsEDS?.eggs_by_donor}
                        placeholder="Search here"
                        mode="multiple"
                        maxTagCount="responsive"
                        // defaultActiveFirstOption={false}
                        // suffixIcon={null}
                        onSearch={(e) => {
                          Object.keys(selectedPatient)?.length > 0 &&
                            globalSearchTextChange(
                              e,
                              selectedLocation,
                              selectedPatient?._id
                            );
                          setTimeout(() => {
                            dispatch(setIsSearchPatient(true));
                          }, 1000);
                        }}
                        onChange={(e) => {
                          handleDonorChange(e, "eggs_by_donor");
                        }}
                        // notFoundContent={null}
                        options={eggsByDonorOptions()}
                        // options={(patientList || []).map((d) => ({
                        //   value: d?._id,
                        //   label: d?.patient_full_name,
                        // }))}
                        maxTagPlaceholder={(omittedValues) => (
                          <Tooltip
                            title={omittedValues
                              .map(({ label }) => label)
                              .join(", ")}
                          >
                            <span>Hover Me</span>
                          </Tooltip>
                        )}
                      />
                      {/* {Object.keys(pDetail).length > 0 && (
                                 <Button
                                   className="clearIcon btn_transparent"
                                   onClick={handleClearSearch}
                                 >
                                   <CloseOutlined />
                                 </Button>
                               )} */}
                    </div>
                    {/* </Form.Item> */}
                  </div>
                </li>
              )}
              {isOpenBy.includes(patientDetailsEDS?.eggs_donor) &&
                embryologyDetails?.cycle_type?.includes("OD") && (
                  <li className="w_270 w_xs_100">
                    {/* <Form.Item
                      label="Eggs By IVF ID "
                      className="custom_select"
                    > */}
                    <div className="custom_select spacing-manage">
                      <label htmlFor="">Eggs By IVF ID</label>
                      <Select
                        showSearch
                        allowClear={false}
                        name="eggs_by_ivf_id_donor"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.label
                            .toLowerCase()
                            .localeCompare(optionB.label.toLowerCase())
                        }
                        placeholder="Select"
                        options={eggsByIvfDonorOptionTemp?.map((d) => ({
                          value: d?._id,
                          label: d?.ivf_id,
                          disabled: d?.disable || false,
                        }))}
                        mode="multiple"
                        maxTagCount="responsive"
                        value={patientDetailsEDS?.eggs_by_ivf_id_donor}
                        maxTagPlaceholder={(omittedValues) => (
                          <Tooltip
                            title={omittedValues
                              .map(({ label }) => label)
                              .join(", ")}
                          >
                            <span>Hover Me</span>
                          </Tooltip>
                        )}
                        onChange={(e) => {
                          handleEggIvfSelectDonor(e || null);
                        }}
                      />
                    </div>
                    {/* </Form.Item> */}
                  </li>
                )}
              {IvfFlowsheetList?.planned_cycle?.includes(
                "Professional Donor"
              ) && (
                <li className="w_270 w_xs_50">
                  {/* <Form.Item
                      label="Eggs To"
                      className={
                        patientDetailsEDS?.eggs_to_donor
                          ? "custom_select select_with_hover"
                          : "custom_select"
                      }
                    > */}
                  <div
                    className={
                      patientDetailsEDS?.eggs_to_donor
                        ? "custom_select spacing-manage select_with_hover"
                        : "custom_select spacing-manage"
                    }
                  >
                    <label htmlFor="">Eggs To</label>
                    <Select
                      showSearch
                      allowClear={true}
                      name="eggs_to_donor"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.label
                          ?.toLowerCase()
                          ?.indexOf(input?.toLowerCase()) >= 0
                      }
                      filterSort={(optionA, optionB) =>
                        optionA.label
                          ?.toLowerCase()
                          ?.localeCompare(optionB?.label?.toLowerCase())
                      }
                      mode="multiple"
                      maxTagCount="responsive"
                      value={patientDetailsEDS?.eggs_to_donor}
                      placeholder="Search here"
                      onSearch={(e) => {
                        Object.keys(selectedPatient)?.length > 0 &&
                          // globalSearchTextChange(e, selectedLocation);
                          searchEggsToTextChange(
                            e,
                            selectedLocation,
                            selectedPatient?._id,
                            "eggs_to_donor"
                          );
                      }}
                      onChange={(value) => {
                        handleStorePatientDetails("eggs_to_donor", value);

                        const currentWithBackupOptionsList = _.uniqBy(
                          [...eggsToDonorPatientList, ...eggsToDonorBackupList],
                          "_id"
                        );

                        const findOptionFromList =
                          currentWithBackupOptionsList?.filter((item) =>
                            value.includes(item?._id)
                          );

                        dispatch(setEggsToDonorPatientList(findOptionFromList));
                        dispatch(setEggsToDonorBackupList(findOptionFromList));
                      }}
                      // options={(patientList || []).map((d) => ({
                      //   value: d?._id,
                      //   label: d?.patient_full_name
                      // }))}
                      options={(eggsToDonorPatientList || []).map((d) => ({
                        value: d?._id,
                        label: d?.patient_full_name,
                      }))}
                      maxTagPlaceholder={(omittedValues) => (
                        <Tooltip
                          title={omittedValues
                            .map(({ label }) => label)
                            .join(", ")}
                        >
                          <span>Hover Me</span>
                        </Tooltip>
                      )}
                    />
                    {/* {Object.keys(pDetail).length > 0 && (
                      <Button
                        className="clearIcon btn_transparent"
                        onClick={handleClearSearchDonor}
                      >
                        <CloseOutlined />
                      </Button>
                    )} */}
                  </div>
                  {/* </Form.Item> */}
                </li>
              )}
            </ul>
          </div>
        )}

      <EmbryologyPartnerDetails />
    </>
  );
};

export default memo(EmbryologyPatientDetails);
